// socialProofData.js
import { fakerEN_US as fakerUS, fakerES as fakerES } from '@faker-js/faker';
import { commonNames, nameWeights } from './commonNames';

// Weighted pick from curated names
function pickWeighted(arr, weights) {
  let total = 0;
  const cumulative = arr.map((name) => {
    const w = weights[name] || 1;
    total += w;
    return [name, total];
  });
  const r = Math.random() * total;
  return cumulative.find(([_, c]) => r < c)?.[0] || arr[arr.length - 1];
}

// Curated first name
function getCuratedFirstName() {
  return pickWeighted(commonNames, nameWeights);
}

// Faker first name (US or Spanish)
function getFakerFirstName() {
  const useSpanish = Math.random() < 0.3; // 30% Spanish, 70% US
  return useSpanish ? fakerES.person.firstName() : fakerUS.person.firstName();
}

// Faker username
function getRandomUsername() {
  return fakerUS.internet.username();
}

// Build names array: curated + faker first names + usernames
const names = [
  ...Array.from({ length: 10 }, getCuratedFirstName), // curated names
  ...Array.from({ length: 10 }, getFakerFirstName), // faker first names
  ...Array.from({ length: 10 }, getRandomUsername), // faker usernames
];

export default {
  names,

  cities: [
    // Core Florida cities
    'Orlando',
    'Tampa',
    'Miami',
    'Jacksonville',

    // Orlando neighborhoods & suburbs
    'Winter Park',
    'Altamonte Springs',
    'Lake Mary',
    'Kissimmee',
    'Sanford',
    'Oviedo',
    'Apopka',
    'Clermont',
    'Maitland',
    'Winter Garden',
    'Ocoee',
    'Windermere',

    // Nearby towns people often travel from
    'Daytona Beach',
    'Cocoa Beach',
    'Melbourne',
    'Lakeland',
  ],

  items: ['Pool Party Ticket', '2 GA Tickets', '3 GA Tickets', 'Cabana Reservation', 'VIP Table'],

  verbs: ['booked', 'purchased', 'secured', 'just bought', 'locked in'],

  weights: {
    items: {
      'Pool Party Ticket': 6,
      '2 GA Tickets': 5,
      '3 GA Tickets': 3,
      'Cabana Reservation': 1,
      'VIP Table': 1,
    },
    cities: {
      Orlando: 6,
      'Winter Park': 3,
      Kissimmee: 2,
      Tampa: 2,
      Miami: 2,
      Jacksonville: 1,
    },
    verbs: {
      booked: 3,
      'just bought': 2,
      secured: 2,
      purchased: 2,
      'locked in': 1,
    },
  },
};
